/**
 * RESPONSIBILITY: every ministry — the one list, in one place.
 *
 * The list is not a Home page detail. It is the church's ministries, shown on Home, in
 * the header menu and on the Ministries page, and edited HERE — one pencil, one place,
 * however many pages read it.
 *
 * Each row carries its own page content too, because a ministry's card and a ministry's
 * page are the same ministry. Adding one is a row, not a deploy.
 *
 * The index page's heading lives on ministries_hero, not here. A pencil should open what
 * it sits over, and this one sits over the grid.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { Ministry } from './rows/ministry';

@Section({ name: SectionName.Ministries, label: 'Ministries' })
export class MinistriesSection {
  @List({ label: 'Ministries', of: () => Ministry, maxItems: 24 })
  ministries!: Ministry[];
}
